<div class="container mt-4 mb-4">
  <h5 class="mb-3">Artefact Statistics</h5>

  <div class="row g-3">
    <div
      class="col-12 col-sm-6 col-md-6 col-lg-4"
      *ngFor="let stat of statsDetails"
      (click)="onStatsCardClick(stat)"
    >
      <div
        class="card rounded-4 p-3 h-100 d-flex flex-row align-items-center justify-content-between"
        style="border-color: #e4e4e4"
      >
        <div>
          <div class="fw-bold">{{ stat.label }}</div>
          <div class="fs-4 fw-semibold mt-1">{{ stat.count }}</div>
          <div class="text-muted small">{{ stat.subLabel }}</div>
        </div>
        <div class="ms-3">
          <img [src]="stat.icon" alt="{{ stat.label }}" />
        </div>
      </div>
    </div>
  </div>

  <div
    class="card mb-4 rounded-4 p-3 h-100 d-flex flex-column gap-4 mt-4"
    style="border-color: #e4e4e4"
  >
    <div class="d-flex gap-2 align-items-center">
      <img src="assets/images/user_profile.svg" />
      <span class="fs-6 fw-semibold"> About </span>
    </div>
    <div>{{ userDetails?.about || "N.A" }}</div>

    <div>
      <div class="text-muted small">Social Links</div>
      <div class="d-flex gap-2">
        <a
          *ngFor="let link of socialLinks"
          target="_blank"
          [href]="link.url"
          ><img width="28" height="28" alt="Social Link" [src]="link.type"
        /></a>
      </div>
    </div>

    <div>
      <div class="text-muted small">Member Since</div>
      <div>{{ userDetails?.createdAt | date : "MMMM yyyy" }}</div>
    </div>
  </div>

  <div
    class="card mb-4 rounded-4 p-3 h-100 d-flex flex-column gap-4"
    style="border-color: #e4e4e4"
  >
    <div class="d-flex gap-2 align-items-center">
      <img src="assets/images/milestole_bdge.svg" />
      <span class="fs-6 fw-semibold"> Milestone Badges </span>
    </div>
    <div class="d-flex flex-wrap gap-4 align-items-center">
      <div *ngFor="let mile of mileStone">
        <img
          [src]="environment.web_url + 'cdn/rank_badges/' + mile + '_userRank.svg'"
        />
      </div>
    </div>
  </div>
</div>
